import {
    useFilteredAvailableTimes,
    useFilteredExperiences,
} from "api/api-hooks/use-available-times";
import { useBookingStateContext } from "hooks/use-booking-state";
import { useMemo } from "react";

/**
 * Hook to create a mapping from rule ID to section name.
 * This can be used to enhance activity data with proper section names.
 */
const useSectionNameMapping = () => {
    const { date } = useBookingStateContext();
    const availableTimesData = useFilteredAvailableTimes(date);
    const filteredExperiences = useFilteredExperiences(date);

    return useMemo(() => {
        if (!availableTimesData)
            return new Map<number, { id: number; name: string; image: string }>();

        const ruleToSectionMap = new Map<number, { id: number; name: string; image: string }>();
        availableTimesData.forEach((section) => {
            section.timeSets.forEach((timeSet) => {
                ruleToSectionMap.set(timeSet.id, {
                    id: section.id,
                    name: section.name,
                    image: section.image,
                });
            });
        });

        filteredExperiences.forEach((experience) => {
            experience.activities.forEach((activity) => {
                activity.timeSets.forEach((timeSet) => {
                    ruleToSectionMap.set(timeSet.id, {
                        id: activity.sectionId,
                        name: activity.sectionName,
                        image: "",
                    });
                });
            });
        });

        return ruleToSectionMap;
    }, [availableTimesData, filteredExperiences]);
};

export { useSectionNameMapping };
